import API from 'config/Axios';

export const CancelTransaction = (orderId) => {
  return API.patch(`/staff/orders/cancel/${orderId}`);
};
